module.exports = __webpack_public_path__ + "img/intro_photo.d169fead.jpeg";